// Scheduler mock data (T7). Deterministic from agent ids — interim API
// contract for /api/scheduler/*.

import { agents } from './dashboard';

export const CRON_PRESETS = {
  weekdayMorning: '0 9 * * 1-5',
  every15: '*/15 * * * *',
  dailyMidnight: '0 0 * * *',
  monthlyFirst: '30 14 1 * *',
  hourly: '0 * * * *'
};

// One scheduled job per agent, staggered across the day.
export const scheduledJobs = agents.map((agent, index) => ({
  id: `job-${agent.id}`,
  agentId: agent.id,
  agentName: agent.name,
  agentIcon: agent.icon,
  title: [
    'Morning brief',
    'Inbox triage',
    'Invoice sweep',
    'Lead enrichment',
    'Ledger sync',
    'Compliance scan'
  ][index % 6],
  cron: [
    CRON_PRESETS.weekdayMorning,
    CRON_PRESETS.every15,
    CRON_PRESETS.dailyMidnight,
    CRON_PRESETS.weekdayMorning,
    CRON_PRESETS.hourly,
    CRON_PRESETS.dailyMidnight
  ][index % 5],
  // Start hour on the timeline (0–23) + duration in hours.
  startHour: (7 + index * 3) % 24,
  durationHours: [1, 2, 1, 3, 1, 2][index % 6],
  lastDecision: [
    'Ran because 3 fresh leads arrived overnight and the pipeline was empty.',
    'Ran because inbox had 12 unread items above the triage threshold.',
    'Skipped because no invoices changed since the last sweep.',
    'Ran because campaign budget needed rebalancing after spend spikes.',
    'Ran because the ledger drifted 2 entries from the warehouse.',
    'Ran because the weekly compliance window opened.'
  ][index % 6]
}));

// Weekly density grid: 7 days × 24 hours of run counts per agent family.
export function schedulerHeatmap() {
  return Array.from({ length: 7 }, (_, day) => (
    Array.from({ length: 24 }, (_, hour) => {
      const business = hour >= 7 && hour <= 19 ? 4 : 0;
      const weekday = day <= 4 ? 1 : 0;
      return ((day * 31 + hour * 7) % 5) + business * weekday;
    })
  ));
}

// Autonomy ledger: newest-first "Agent X decided to run Y because Z".
export const autonomyLedger = agents.flatMap((agent, index) => ([
  {
    id: `dec-${agent.id}-1`,
    agentName: agent.name,
    agentIcon: agent.icon,
    jobTitle: scheduledJobs[index % scheduledJobs.length].title,
    decision: 'run',
    reason: scheduledJobs[index % scheduledJobs.length].lastDecision,
    minutesAgo: 4 + index * 9
  },
  {
    id: `dec-${agent.id}-2`,
    agentName: agent.name,
    agentIcon: agent.icon,
    jobTitle: scheduledJobs[(index + 2) % scheduledJobs.length].title,
    decision: 'skip',
    reason: 'Predicted value below the autonomy threshold for this window.',
    minutesAgo: 26 + index * 13
  }
])).sort((a, b) => a.minutesAgo - b.minutesAgo);
